module.exports = __webpack_public_path__ + "h5/img/mfe_06.d42e285b.jpeg";